export default "__VITE_ASSET__BRj4km8x__"